import { render } from "./UsuarioPerfilVie.vue?vue&type=template&id=0d92f1b3&scoped=true"
import script from "./UsuarioPerfilVie.vue?vue&type=script&lang=js"
export * from "./UsuarioPerfilVie.vue?vue&type=script&lang=js"

import "./UsuarioPerfilVie.vue?vue&type=style&index=0&id=0d92f1b3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d92f1b3"]])

export default __exports__